import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';

export type LegacyRouteState = {
  name: string;
  url: string;
  params: { [name: string]: string };
};

const DefaultRouteState = {
  name: '',
  url: '',
  params: {},
};

@Injectable({
  providedIn: 'root',
})
export class LegacyRouterService {
  private routeState: BehaviorSubject<LegacyRouteState> = new BehaviorSubject<LegacyRouteState>(DefaultRouteState);

  constructor(private _router: Router) {}

  public loadRouteState(state: LegacyRouteState) {
    this.routeState.next(state);
  }

  public getRouteState(): Observable<LegacyRouteState> {
    return this.routeState.asObservable();
  }

  /*
    These public methods have the same names and accept the same first argument
    as their equivalents on the Angular router. We can use these in place
    of the Angular versions until the routing is fully migrated.
  */
  public async navigateByUrl(url: string | UrlTree): Promise<boolean> {
    const serializedUrl = this._isUrlTree(url) ? this._router.serializeUrl(url) : url;
    window.location.href = serializedUrl;
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async navigate(commands: any[]): Promise<boolean> {
    return this.navigateByUrl(this._router.createUrlTree(commands));
  }

  private _isUrlTree(v: unknown): v is UrlTree {
    return v instanceof UrlTree;
  }
}
